import React, {Component} from 'react'
import {withStyles} from "@material-ui/core";

const style = (theme) => ({
    logo: {
        width: 130,
        [theme.breakpoints.down('md')]: {
            width: 100,
        },
        [theme.breakpoints.down('sm')]: {
            width: 80,
        },
        [theme.breakpoints.down('xs')]: {
            width: 50,
        },
    }
})

class MainLogo extends Component {
    render() {
        const { classes } = this.props
        return (
            <header>
                <a data-scroll-nav="0" href="#0">
                    <img src="./img/geniamlog.png" alt="" className={classes.logo}/>
                </a>

                <a href="#navigation" className="nav-trigger" style={{ display: 'none' }}>
                </a>
            </header>
        );
    }
}

export default withStyles(style)(MainLogo)
